import { render, staticRenderFns } from "./CategoryFilter.vue?vue&type=template&id=7108c484&scoped=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=js"
export * from "./CategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./CategoryFilter.vue?vue&type=style&index=0&id=7108c484&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7108c484",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7108c484')) {
      api.createRecord('7108c484', component.options)
    } else {
      api.reload('7108c484', component.options)
    }
    module.hot.accept("./CategoryFilter.vue?vue&type=template&id=7108c484&scoped=true", function () {
      api.rerender('7108c484', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/international/components/CategoryFilter.vue"
export default component.exports